import { render, staticRenderFns } from "./DashboardRevenueCard.vue?vue&type=template&id=9efad81c&"
import script from "./DashboardRevenueCard.vue?vue&type=script&lang=js&"
export * from "./DashboardRevenueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports